export default __webpack_public_path__ + "static/media/100003.7a0472df.jpg";